import { render } from "./DefaultTimeForStartDateAndEndDate.vue?vue&type=template&id=28e68652"
import script from "./DefaultTimeForStartDateAndEndDate.vue?vue&type=script&lang=ts"
export * from "./DefaultTimeForStartDateAndEndDate.vue?vue&type=script&lang=ts"
script.render = render

export default script